import type { AnyFeaturePack } from "@/core/features/index.ts";
import { AUDIODSP_WASM_URL, loadAudioDsp } from "./wasm/audiodsp.ts";
import { IMAGEOPS_WASM_URL, loadImageOps } from "./wasm/imageops.ts";

/** Measured from the release builds; shown before the download starts. */
const IMAGEOPS_SIZE_BYTES = 185_000;
const AUDIODSP_SIZE_BYTES = 52_000;

export const IMAGEOPS_PACK = {
  id: "imageops",
  label: "画像の高品質処理",
  description: "きれいな縮小と、ファイルサイズを指定した書き出しに使います",
  sizeBytes: IMAGEOPS_SIZE_BYTES,
  assetUrl: IMAGEOPS_WASM_URL,
  requires: [],
  unavailableReason: () => null,
  load: loadImageOps,
} as const satisfies AnyFeaturePack;

export const AUDIODSP_PACK = {
  id: "audiodsp",
  label: "音声の処理",
  description: "波形の表示、音量調整、イコライザ、書き出しに使います",
  sizeBytes: AUDIODSP_SIZE_BYTES,
  assetUrl: AUDIODSP_WASM_URL,
  requires: [],
  unavailableReason: () => null,
  load: loadAudioDsp,
} as const satisfies AnyFeaturePack;

/** Every downloadable module the app knows about; the registry is built from this list. */
export const FEATURE_PACKS: readonly AnyFeaturePack[] = [IMAGEOPS_PACK, AUDIODSP_PACK];
